import { connect } from 'react-redux';
import type { ThunkDispatch } from '@reduxjs/toolkit';
import SummaryScreen from './SummaryScreen.View';
import type { OwnProps, StateProps } from './SummaryScreen.View';
import type { RootState } from '../../store/Store';
import { addHighscoreEntry, loadHighscore } from '../../store/HighscoreSlice';
import {
	currentTotalScoreSelector,
	sortedEntriesSelector
} from '../../store/Selectors';
import type { TotalScore } from '../../data/Score';
import { sumPoints } from '../../data/Score';

const mapStateToProps = (state: RootState, _: OwnProps): StateProps => {
	const score = currentTotalScoreSelector(state);
	const points = sumPoints(score);
	return {
		playerName: state.playthrough.playerName,
		highscoreEntries: sortedEntriesSelector(state),
		score,
		points
	};
};

const mapDispatchToProps = (dispatch: ThunkDispatch<unknown, unknown, any>) => {
	return {
		loadHighscore: async (): Promise<void> => {
			await dispatch(loadHighscore());
		},
		addHighscoreEntry: async (
			playerName: string,
			score: TotalScore
		): Promise<void> => {
			await dispatch(addHighscoreEntry({ playerName, score }));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryScreen);
